import {IImageManualModel, IImageModel, IManualFinderFilterModel, IManualModel} from "../../types/manualFinder";

export const createPdfFileUploadSlice = (set: any, get: any) => ({
    ...createPdfFileUploadStates(set, get),
    ...createPdfFileUploadActions(set, get),
});

export const getLocalItem = (key: string, defaultValue: any = ''): any => {
    return window.localStorage.getItem(key) || defaultValue;
};

export const setLocalItem = (key: string, value: any = ''): void => {
    window.localStorage.setItem(key, value);
};

const createPdfFileUploadStates = (set: any, get: any) => ({
    uploadComplete: false,
    fileMap: {} as Record<string, string>,
    uploadedFiles: [] as File[],
    filesUploaded: false,
    extractionFinished: false,
    extractedImages: [] as Record<string, IImageModel>[],
    specialTools: [] as string[],
    manualsBasedOnSpecialTools: [] as IManualModel[],
    manualsBasedOnImages: [] as IImageManualModel[],

    setUploadComplete: (status: boolean) => set({uploadComplete: status}),

    setExtractionFinished: (status: boolean) => set({extractionFinished: status}),

    setFileMap: (fileData: { fileName: string; eTag: string }) =>
        set((state: any) => ({
            fileMap: {
                [fileData.fileName]: fileData.eTag,
                ...state.fileMap,
            },
        })),

    setUploadedFiles: (file: File) =>
        set((state: any) => ({
            uploadedFiles: [file, ...state.uploadedFiles],
        })),

    clearFileMap: () => set({fileMap: {}}),

    clearUploadedFiles: () => set({uploadedFiles: []}),

    setSpecialTools: (tools: string[]) => set({specialTools: tools}),

    setExtractedImages: (images: Record<string, IImageModel>[]) => set({extractedImages: images}),

    setManualsBasedOnSpecialTools: (manuals: IManualModel[]) => set({manualsBasedOnSpecialTools: manuals}),

    setManualsBasedOnImages: (manuals: IImageManualModel[]) => set({manualsBasedOnImages: manuals}),

    setManualFinderFilterProps: (newState: Partial<IManualFinderFilterModel>) => set((prevState: any) => ({...prevState, ...newState})),
});

const createPdfFileUploadActions = (set: any, get: any) => ({
    resetState: () => {
        set({
            uploadComplete: false,
            fileMap: {},
            uploadedFiles: [],
            extractionFinished: false,
            extractedImages: [],
            specialTools: [],
            manualsBasedOnSpecialTools: [],
            manualsBasedOnImages: [],
            manualFinderFilterProps: {
                threshold: 0.5,
                imageAutoSelectionTopK: 10,
                topK: 5,
                manufacturers: [],
                selectedManufacturers: [],
                itemMPOptions: [],
                extractOptions: [],
                selectedItemMP: null,
                selectedExtractItem: null,
            },
        });
    },
});
